import { showErrorToast, showSuccessToast } from "../toastUtils";
import { getErrorMessage } from "../error-helpers/errorMessage";
import removeMarkdown from "remove-markdown"; // Install with: npm install remove-markdown

export const formatElapsedTime = (elapsedTime: number): string => {
  const minutes = Math.floor(elapsedTime / 60); // Calculate full minutes
  const seconds = elapsedTime % 60; // Get the remainder seconds
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds; // Add leading 0 if necessary
  return `${minutes}:${formattedSeconds}`;
};

// Helper function to decode URL-encoded text
const decodeText = (text: string): string => {
  try {
    // First, try to decode URL-encoded text
    let decodedText = decodeURIComponent(text);
    
    // If the text still contains encoded characters, try again
    // This handles double-encoding scenarios
    while (decodedText !== text && decodedText.includes('%')) {
      text = decodedText;
      decodedText = decodeURIComponent(text);
    }
    
    return decodedText;
  } catch (error) {
    // If decoding fails, return the original text
    return text;
  }
};

export const copyToClipboard = async (text: string) => {
  try {
    const contentToCopy = text; // Raw Markdown text
    if (contentToCopy) {
      // First decode any URL-encoded characters
      const decodedText = decodeText(contentToCopy);
      
      const removedMarkdown = removeMarkdown(decodedText, {
        stripListLeaders: false,
        useImgAltText: true,
      });
      navigator.clipboard
        .writeText(removedMarkdown)
        .then(() => showSuccessToast("Copied to clipboard!"))
        .catch((err) => alert(`Failed to copy: ${err.message}`));
    }
  } catch (e) {
    // Fallback: try to decode and copy the raw text
    try {
      const decodedText = decodeText(text);
      navigator.clipboard
        .writeText(decodedText)
        .then(() => showSuccessToast("Copied to clipboard!"))
        .catch((err) =>
          showErrorToast(`Failed to copy: ${getErrorMessage(err)}`),
        );
    } catch (decodeError) {
      // If all else fails, copy the original text
      navigator.clipboard
        .writeText(text)
        .then(() => showSuccessToast("Copied to clipboard!"))
        .catch((err) =>
          showErrorToast(`Failed to copy: ${getErrorMessage(err)}`),
        );
    }
  }
};
